import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import helperNumbers from "../../../helpers/numbers";
import ButtonDisable from "../other/ButtonDisable";
import UserExample from "../../sections/user/UserExample";

export default function User() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const body = document.querySelector("body");
    const except = document.querySelector("#popover-user-icon-nav");
    body.addEventListener(
      "click",
      function () {
        setShow(false);
      },
      false
    );
    except.addEventListener(
      "click",
      function (ev) {
        ev.stopPropagation();
      },
      false
    );
  });

  return (
    <div className="d-flex">
      <div className="nav-item d-sm-inline-block">
        <span
          className={`nav-link p-0 mr-2  position-relative btn btn-power-off ${
            show && "btn-power-off-hover"
          }`}
          onClick={(e) => {
            e.stopPropagation();
            setShow((prevState) => {
              return !prevState;
            });
          }}
        >
          <i className="fa fa-user"></i>
        </span>
        <div
          className={`${show ? "" : "d-none"}   position-absolute`}
          id="popover-user-icon-nav"
        >
          <div className="d-flex justify-content-end  position-relative">
            <div className="icon-triangle "></div>
          </div>
          <div className="popover-body p-3 ">
            <div className="py-2">
              <span>نام کاربری</span>
              <span className="px-2">:</span>
              <span className="d-inline-flex">
                <p className="pl-1 m-0">{UserExample.firstName}</p>
                <p className="m-0">{UserExample.lastName}</p>
              </span>
            </div>
            <div className="py-2">
              <span>شماره کاربری</span>
              <span className="px-2">:</span>
              <span>{helperNumbers.toPersianNum(UserExample.ID)}</span>
            </div>
            <div className="py-2">
              <span>نقش</span>
              <span className="px-2">:</span>
              <span>مشتری همکار</span>
            </div>
            <div className="py-2">
              <span>اطلاعات ضروری</span>
            </div>
            <div className="py-2">
              <span>شماره موبایل</span>
              <span className="px-2">:</span>
              <span dir="ltr">
                {helperNumbers.toPersianNum(
                  helperNumbers.presentMobileNumber(UserExample.mobile)
                )}
              </span>
            </div>
            <div className="py-2">
              <span>ایمیل</span>
              <span className="px-2">:</span>
              <span>{UserExample.email}</span>
            </div>

            <div className="py-2">
              <div className="border border-1 border-success"></div>
            </div>
            <div className="py-2 d-flex justify-content-between">
              <Link to="/user/info-customer-coworker" className="btn btn-info">
                <i className="hl-user pl-2 align-middle"></i>
                اطلاعات کاربری
              </Link>

              <ButtonDisable
                buttonTagHtml={
                  <span className="btn btn-danger opacity-50">
                    <i className="hl-logout-a pl-2 align-middle "></i>
                    خروج از پنل
                  </span>
                }
              ></ButtonDisable>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
